/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-instructions.reducer';

export const PreOpInstructionsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpInstructionsEntity = useAppSelector(state => state.preOpInstructions.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpInstructionsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpInstructions.detail.title">PreOpInstructions</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.id}</dd>
          <dt>
            <span id="nilByMouthFrom">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.nilByMouthFrom">Nil By Mouth From</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.nilByMouthFrom}</dd>
          <dt>
            <span id="reserveBloodProducts">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.reserveBloodProducts">Reserve Blood Products</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.reserveBloodProducts}</dd>
          <dt>
            <span id="preMedications">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.preMedications">Pre Medications</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.preMedications}</dd>
          <dt>
            <span id="specificInstructions">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.specificInstructions">Specific Instructions</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.specificInstructions}</dd>
          <dt>
            <span id="otherSpecificInstructions">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.otherSpecificInstructions">Other Specific Instructions</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.otherSpecificInstructions}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpInstructions.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpInstructionsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpInstructions.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpInstructionsEntity.surgery ? preOpInstructionsEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpInstructions.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOpInstructionsEntity.anaesthesiologist ? preOpInstructionsEntity.anaesthesiologist.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-instructions" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-instructions/${preOpInstructionsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpInstructionsDetail;
